export function parseOptions(options) {
  const parseOptions = {
    className: '',
    title: '',
    ...options,
  }

  return parseOptions
}
